"use strict";

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var inputSizesCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  if (props.size === 'xs') {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 0.8em;\n      ";
  }

  if (props.size === 'sm') {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 0.8em;\n      ";
  }

  if (props.size === 'md' || !props.size) {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 1em;\n      ";
  }

  if (props.size === 'lg') {
    return "\n        padding: 0.8em;\n        font-size: 1.2em;\n      ";
  }

  if (props.size === 'xl') {
    return "\n        width: 100%;\n        padding: 0.8em 0.5em;\n        font-size: 1.6em;\n        text-align: center;\n      ";
  }

  return "\n      padding: 0.8em 0.5em;\n      font-size: 1.1em;\n    ";
});
var _default = inputSizesCSS;
exports["default"] = _default;